<template>
  <div class="plaid-introduction">
    <LottiePlayer
      :height="150"
      :width="150"
      :animation-data="animationData"
      :loop="false"
    />

    <p class="plaid-introduction__text">
      Your data is kept safe and private with best-in-class encryption protocols like the Advanced Encryption Standard (AES 256) and Transport Layer Security (TLS).
    </p>

    <div
      class="plaid-introduction-learn-more"
      @click="showPartnership = !showPartnership"
    >
      Learn more
      <font-awesome-icon
        v-if="!showPartnership"
        class="ml-5"
        icon="chevron-down"
      />
      <font-awesome-icon
        v-if="showPartnership"
        class="ml-5"
        icon="chevron-up"
      />
    </div>

    <div
      v-if="showPartnership"
      class="plaid-introduction-parternship"
    >
      <img
        class="mx-auto h-100"
        :src="require('@/assets/svg/plaid/plaid.svg')"
        alt="plaid logo"
      >
      <p class="font-bold text-black-500 my-20">
        Partnership with Plaid
      </p>
      <p>
        Plaid is a secure, audited, and trusted company that has built partnerships with most major financial institutions and thousands of
        credit unions across the country. They are a trusted provider for many major financial apps and services.
      </p>
    </div>

    <img
      class="mx-auto my-20"
      :src="require('@/assets/svg/plaid/shield-check.svg')"
      alt="shield check"
    >
    <p class="plaid-introduction__subheading">
      Your Security Is Our Top Priority
    </p>
    <div class="border-2 w-100 mx-auto mt-20 mb-30" />
    <PlaidSecurityInfo />

    <AppButton
      class="my-40 mx-auto"
      @click="$emit('continue')"
    >
      Continue
    </AppButton>

    <p
      class="cursor-pointer text-purple-500 underline mt-100"
      @click="showPopup = true"
    >
      Why is this needed?
    </p>

    <PlaidPopup
      v-if="showPopup"
      @hide="showPopup = false"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import LottiePlayer from '@/components/common/lottie/LottiePlayer.vue'
import PlaidSecurityInfo from './PlaidSecurityInfo.vue'
import AppButton from '@/components/common/buttons/AppButton'
import PlaidPopup from '@/components/common/plaid/PlaidPopup.vue'

export default {
  name: 'PlaidEducation',

  components: {
    LottiePlayer,
    PlaidSecurityInfo,
    AppButton,
    PlaidPopup
  },

  data () {
    return {
      animationData: require('@/assets/lottie/plaid/secure-bank.json'),
      showPartnership: false,
      showPopup: false
    }
  }
}
</script>

<style lang="scss" scoped>
.plaid-introduction {
  @apply text-center max-w-500 mx-auto;

  &__text {
    @apply my-30 text-base font-body font-normal text-gray-500;
  }

  &-learn-more {
    @apply mt-50 font-semibold cursor-pointer;
  }

  &__subheading {
    @apply font-display font-semibold;

    font-size: 30px;
    line-height: 36px;
  }

  &-parternship {
    @apply my-30 text-base font-body font-normal text-gray-500 max-w-500;
  }
}
</style>
